
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressData from 'vux/src/datas/china_address.json'
import Datetime from 'vux/src/components/datetime/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: "PromptInforWrap",
components: {
XHeader,Group,Cell,XAddress,Datetime,Selector,XTextarea,XInput,XButton
},
data(){
return{
travelInfo: '出行信息',
schoolBusInfo: '校车信息',
classmatesInfo: '同行同学推荐',
title: "到校信息",
addressData: ChinaAddressData,
addressValue: ["陕西省"],
overValue: ["西安市"],
outTime: "2011-08-31",
arriveTime: "2011-09-01",

travelValue: "",
scBusValuel: "",
numberValue: ""
}
},
computed:{

},
methods:{
reduce(){

},
add(){

}
}
}



// WEBPACK FOOTER //
// ./src/components/PromptInformation.vue